import { mergeCanAccess } from './companyFeatures.js';
import {
  hasAttendanceAccess,
  hasExternalCommissionAccess,
  hasInternalCommissionDashboardAccess,
  hasMlAgentCommissionAccess,
  hasOnContractAccess,
  hasOnContractTruckAccess,
} from './networkMode.js';

/**
 * Which /dashboard/* endpoints may be loaded for this user + company can_access.
 * UI sections use the same helpers; this keeps network traffic aligned.
 */
export function dashboardFetchFlags(user, { includeUsersVehicles = false, includeMlDues = false } = {}) {
  if (!user) {
    return {
      shipment: false,
      cargoOverview: false,
      bookingSummary: false,
      commission: false,
      onContract: false,
      tripContract: false,
      attendance: false,
      salary: false,
      mlAgentDues: false,
      usersVehicles: false,
      hubList: false,
    };
  }

  const role = user.role || user.role_name;
  const isSystemAdmin = role === 'System Admin';
  const features = mergeCanAccess(user.company_features || user.company_can_access || {});

  const shipment = isSystemAdmin || Boolean(features.shipment);
  const commission = isSystemAdmin
    || hasInternalCommissionDashboardAccess(user)
    || hasExternalCommissionAccess(user);
  const onContract = hasOnContractAccess(user);
  const tripContract = hasOnContractTruckAccess(user);
  const attendance = hasAttendanceAccess(user);
  const salary = attendance;
  const cargoOverview = shipment && Boolean(user.is_cargo_shipment);
  const bookingSummary = shipment;
  const mlAgentDues = Boolean(includeMlDues && hasMlAgentCommissionAccess(user));
  const usersVehicles = Boolean(includeUsersVehicles && shipment);
  const hubList = (role === 'Admin' || role === 'Accountant')
    && (shipment || commission || attendance || cargoOverview);

  return {
    shipment,
    cargoOverview,
    bookingSummary,
    commission,
    onContract,
    tripContract,
    attendance,
    salary,
    mlAgentDues,
    usersVehicles,
    hubList,
  };
}
